module.exports = __webpack_public_path__ + "media/click.8feb0a16.mp3";